import React, { useRef, forwardRef } from "react";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import moment from "moment";
import { CalenderIcon } from "../../../assets/CommonSvg";

const CustomInput = forwardRef(({ format, value, onClick, label, placeholder, disabled, className }, ref) => (
  <div className={`relative w-full ${label ? ' mt-6' : ' mt-6'} mb-2.5`}>
    <input
      style={{
        ...(disabled && { backgroundColor: "#F0F1F5", color: "#5c5959" }),
        border: "1px solid",
        padding: "13px"
      }}

      className={`date-picker-custom-class block w-full h-full  !border-[#F0F1F5] bg-[#FFFFFF] rounded-[6px]   outline-none  ` + className}
      onClick={onClick}
      value={value ? moment(value).format(format) : ""}
      placeholder={placeholder}
      readOnly
      ref={ref}
      disabled={disabled}
    />
    {!disabled &&
      <span
        className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
        onClick={onClick}
      >
        <CalenderIcon />
      </span>}
  </div>
));

const DatePickerField = ({
  className,
  handleChange,
  value,
  InputId,
  InputName,
  format,
  placeholder,
  disabled,
  minDate = true,
  maxDate,
  ...props
}) => {
  const datePickerRef = useRef(null);

  return (
    <div className="relative w-full">
      <DatePicker
        ref={datePickerRef}
        selected={value ? moment(value, "DD/MM/YYYY").toDate() : null}
        onChange={(date) => handleChange(moment(date).format("DD/MM/YYYY"))} // Save in DD/MM/YYYY format
        id={InputId}
        name={InputName}
        placeholderText={placeholder}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        minDate={typeof minDate === "boolean" ? (minDate ? new Date() : null) : new Date(minDate)}
        maxDate={maxDate ? new Date(maxDate) : null}
        disabled={disabled}
        onFocus={(event) => event.target.setAttribute("autocomplete", "off")}
        customInput={<CustomInput value={value} placeholder={placeholder} disabled={disabled} className={className} format={format} />}
        wrapperClassName="block w-full"
        popperClassName="custom-datepicker"
        {...props}
      />
    </div>
  );
};

DatePickerField.propTypes = {
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  InputId: PropTypes.string,
  InputName: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  minDate: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.instanceOf(Date)]),
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
};

export default DatePickerField;
